import { Component, OnInit, AfterViewInit, OnDestroy } from "@angular/core";
import {
    CclNavbarSecondaryService,
    CclDrawerService,
    CclNavbarFooterService,
    CclMessageService
} from "certain-common-library";
import { SharedService } from "../../../../../modules/shared/services/shared.service";
import { LocalDataService } from "../../../../../modules/shared/services/local-data.service";
import { Subscription } from "rxjs";
import { CatalogService } from "../../../../../modules/shared/services/catalog.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { cloneDeep } from "lodash";

import { UnsavedChangesDeactivate } from "../../../can-deactivate";
@Component({
    selector: "app-theme-page",
    templateUrl: "./theme-page.view.html",
    styleUrls: []
})
export class ThemePageView extends UnsavedChangesDeactivate implements AfterViewInit, OnInit, OnDestroy {
    subscription: Subscription;
    catalogLayoutConfig: any = {};
    selectdTheme: any;
    oldTheme: any;
    jsonConfig: any;
    theme:any;

    themes: Array<any> = [];
    constructor(
        private navSecondaryService: CclNavbarSecondaryService,
        public sharedService: SharedService,
        private localDataService: LocalDataService,
        private navbarFooterService: CclNavbarFooterService,
        private messageService: CclMessageService,
        private catalogService: CatalogService,
        private _flashMessagesService: FlashMessagesService,
        private drawerService: CclDrawerService
    ) {
        super(sharedService);
        this.navSecondaryService.sectionLabel = "Define Layout";
        this.subscription = this.messageService.getMessage().subscribe((message) => this.saveThemeConfig(message));
    }

    ngOnInit() {
        this.drawerService.closeMessage = null;
        this.catalogLayoutConfig = this.sharedService.setup;
        this.jsonConfig = JSON.parse(this.sharedService.setup.layoutConfig);
        this.localDataService.getJSON("themes.json").subscribe((data) => {
            if (data != null) {
                this.themes = data;
            }
            let index = this.themes.findIndex(item => item.name === this.jsonConfig?.theme?.name);
            if (this.jsonConfig.theme != null && index == -1) {
                this.themes.splice(0, 0, this.jsonConfig.theme);
            }
            this.themes.forEach((theme) => {
                if (theme.id == this.catalogLayoutConfig.themeId) {
                    this.theme = theme;
                    this.selectdTheme = theme;
                    this.oldTheme = cloneDeep(theme);
                }
            });

            // For checking unsaved data
            this.sharedService.originalData = cloneDeep(this.catalogLayoutConfig);
            this.sharedService.changedData = this.catalogLayoutConfig;
        });
    }

    ngOnDestroy() {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    saveThemeConfig(message) {
        if (message.text == "save-theme" || message.text == "save-next-theme") {
            this.oldTheme = cloneDeep(this.selectdTheme);
            this.selectdTheme = this.theme;
            if (this.catalogLayoutConfig.themeId == 0) {
                this.jsonConfig.theme = this.selectdTheme;
                this.sharedService.setup.layoutConfig = JSON.stringify(this.jsonConfig);
            }

            if (this.sharedService.setup.id != null) {
                this.sharedService.objectKeys(this.sharedService.configs).forEach((key) => {
                    let config = JSON.parse(this.sharedService.configs[key].config);

                    if (key == this.sharedService.configTypes.TAB_CONFIG) {
                        this.setColorForTabConfigHelper(config);
                    } else if (key == this.sharedService.configTypes.FILTER_CONFIG) {
                        this.setColorForFilterConfigHelper(config);
                    } else if (key == this.sharedService.configTypes.SPEAKER_CONFIG) {
                        this.setColorForSpeakerConfigHelper(config);
                    } else if (
                        key == this.sharedService.configTypes.SESSION["highlighted"] ||
                        key == this.sharedService.configTypes.SESSION["promoted"] ||
                        key == this.sharedService.configTypes.SESSION["general"]
                    ) {
                        this.setColorForSessionConfigHelper(config);
                    } else if (key == this.sharedService.configTypes.MYSESSION) {
                        this.setColorForMySessionHelper(config);
                    } else if (key == this.sharedService.configTypes.HEADER_FOOTER["header"]) {
                        if (this.oldTheme != null) {
                            this.sharedService.configs[key].config = this.sharedService.configs[key].config.replace(
                                this.oldTheme.config.header,
                                this.selectdTheme.config.header
                            );
                            config = JSON.parse(this.sharedService.configs[key].config);
                        }
                    } else if (key == this.sharedService.configTypes.HEADER_FOOTER["footer"]) {
                        if (this.oldTheme != null) {
                            this.sharedService.configs[key].config = this.sharedService.configs[key].config.replace(
                                this.oldTheme.config.footer,
                                this.selectdTheme.config.footer
                            );
                            config = JSON.parse(this.sharedService.configs[key].config);
                        }
                    } else if (key == this.sharedService.configTypes.LOGIN_POPUP) {
                        this.setColorForLoginPopupHelper(config);
                    }

                    this.sharedService.configs[key].config = JSON.stringify(config);
                });
                this.sharedService.setup.themeId = this.selectdTheme.id;
                let tempSetup = cloneDeep(this.sharedService.setup);
                tempSetup.setupConfigs = Object.keys(this.sharedService.configs).map(e => this.sharedService.configs[e]);

                this.catalogService.saveSetup(tempSetup).subscribe((resp) => {
                    // For checking unsaved data
                    this.sharedService.originalData = cloneDeep(this.catalogLayoutConfig);
                    this.sharedService.changedData = this.catalogLayoutConfig;

                    this.oldTheme = cloneDeep(this.selectdTheme);
                    this.sharedService.setup = resp.body["sessionCatalogSetupDTO"];
                    this.sharedService.setup.setupConfigs = null;
                    this._flashMessagesService.show("Theme saved successfully.", { cssClass: "alert-success" });

                    if (message.text == "save-next-theme") {
                        this.sharedService.catalogNavigateHelper("admin", "catalog/layout/header");
                    }
                });
            } else {
                this.catalogService.saveSetup(this.sharedService.setup).subscribe((resp) => {
                    // For checking unsaved data
                    this.sharedService.originalData = cloneDeep(this.catalogLayoutConfig);
                    this.sharedService.changedData = this.catalogLayoutConfig;

                    this.sharedService.setup = resp.body["sessionCatalogSetupDTO"];
                    this.sharedService.setup.setupConfigs = null;
                    this._flashMessagesService.show("Theme saved successfully.", { cssClass: "alert-success" });

                    let listArray = ["highlighted", "promoted", "general"];
                    // update Tab config
                    this.setColorForTabConfigHelper(this.sharedService.tabConfig);

                    // update filter config
                    this.setColorForFilterConfigHelper(this.sharedService.filterSetup);

                    // update speaker config
                    this.setColorForSpeakerConfigHelper(this.sharedService.speakerLayoutConfig);

                    // update session config
                    listArray.forEach((element) => {
                        this.setColorForSessionConfigHelper(this.sharedService.sessionLayoutConfig[element]);
                    });

                    this.setColorForMySessionHelper(this.sharedService.sessionLayoutConfig["mysession"]);

                    if (message.text == "save-next-theme") {
                        this.sharedService.catalogNavigateHelper("admin", "catalog/layout/header");
                    }
                });
            }
            this.sharedService.createCss(this.catalogService);
        } else if (message.text == "apply-theme-config") {
            this.sharedService.customTheme.id = 0;
            this.sharedService.customTheme.name = "Custom Theme";
            this.catalogLayoutConfig.themeId = 0;
            this.selectdTheme = this.sharedService.customTheme;
            this.theme = this.sharedService.customTheme;
            if (this.themes.length == 4) {
                this.themes.splice(0, 0, this.sharedService.customTheme);
            } else {
                this.themes[0] = this.sharedService.customTheme;
            }
            this.drawerService.hideDrawer();
        }
    }

    setColorForSessionConfigHelper(config) {
        config.labelConfig.fontColor = this.selectdTheme.config.type_2;
        config.catalogConfig.header.regionConfig.background = this.selectdTheme.config.background;
        config.catalogConfig.header.textConfig.background = this.selectdTheme.config.background;
        config.catalogConfig.header.textConfig.textColor = this.selectdTheme.config.type_1;
        config.catalogConfig.body.regionConfig.background = this.selectdTheme.config.background;
        config.catalogConfig.body.textConfig.background = this.selectdTheme.config.background;
        config.catalogConfig.body.textConfig.textColor = this.selectdTheme.config.type_1;
    }
    setColorForTabConfigHelper(config) {
        config.activeBorderColor = this.selectdTheme.config.accent;
        config.inactiveBorderColor = this.selectdTheme.config.background;
        config.activeLabelColor = this.selectdTheme.config.type_1;
        config.inactiveLabelColor = this.selectdTheme.config.type_2;
    }
    setColorForFilterConfigHelper(config) {
        config.header.backgroundColor = this.selectdTheme.config.accent;
        config.header.fontColor = this.selectdTheme.config.background;
        config.body.backgroundColor = this.selectdTheme.config.background;
        config.body.fontColor = this.selectdTheme.config.type_2;
    }
    setColorForSpeakerConfigHelper(config) {
        config.labelConfig.fontColor = this.selectdTheme.config.type_2;
        config.catalogConfig.body.regionConfig.background = this.selectdTheme.config.background;
        config.catalogConfig.body.textConfig.background = this.selectdTheme.config.background;
        config.catalogConfig.body.textConfig.textColor = this.selectdTheme.config.type_1;
    }

    setColorForLoginPopupHelper(config) {
        config.header.label_color = this.selectdTheme.config.background;
        config.header.background = this.selectdTheme.config.accent;
        config.body.background = this.selectdTheme.config.background;
        config.footer.background = this.selectdTheme.config.background;
        config.footer.button.primary.background = this.selectdTheme.config.accent;
        config.footer.button.primary.color = this.selectdTheme.config.background;
        config.footer.button.secondary.background = this.selectdTheme.config.background;
        config.footer.button.secondary.color = this.selectdTheme.config.accent;
    }

    setColorForMySessionHelper(config) {
        config.drawer_button.background = this.selectdTheme.config.accent;
        config.my_schedule.my_schedule_drawer_button.background = this.selectdTheme.config.accent;
        config.drawer_button.color = this.selectdTheme.config.background;
        config.my_schedule.my_schedule_drawer_button.color = this.selectdTheme.config.background;

        config.header.background = this.selectdTheme.config.accent;
        config.my_schedule.my_schedule_header.background = this.selectdTheme.config.accent;
        config.header.label_color = this.selectdTheme.config.background;
        config.my_schedule.my_schedule_header.label_color = this.selectdTheme.config.background;
        config.header.icon_color = this.selectdTheme.config.background;
        config.my_schedule.my_schedule_header.icon_color = this.selectdTheme.config.background;

        config.tabConfig.activeBorderColor = this.selectdTheme.config.accent;
        config.tabConfig.inactiveBorderColor = this.selectdTheme.config.background;
        config.tabConfig.activeLabelColor = this.selectdTheme.config.type_1;
        config.tabConfig.inactiveLabelColor = this.selectdTheme.config.type_2;

        config.button.primary.background = this.selectdTheme.config.accent;
        config.button.primary.color = this.selectdTheme.config.background;

        config.button.secondary.background = this.selectdTheme.config.background;
        config.button.secondary.color = this.selectdTheme.config.accent;

        config.catalogConfig.header.regionConfig.background = this.selectdTheme.config.background;
        config.catalogConfig.header.textConfig.background = this.selectdTheme.config.background;
        config.catalogConfig.header.textConfig.textColor = this.selectdTheme.config.type_1;
    }

    ngAfterViewInit(): void {
        if (this.navbarFooterService.navbar != null && this.navbarFooterService.navbar.rightNavbarItems != null) {
        this.navbarFooterService.navbar.rightNavbarItems[0].label = "Next Step: Design Elements";
        this.navbarFooterService.navbar.rightNavbarItems[1].message = "save-theme";
        this.navbarFooterService.navbar.rightNavbarItems[2].message = "save-next-theme";
    }
        this.messageService.sendMessage("update-publish-button");
    }

    useTheme(theme) {
        this.catalogLayoutConfig.themeId = theme.id;
        this.theme = theme;
    }

    customizeTheme(theme, $event) {
        $event.stopPropagation();
        this.drawerService.toggleDrawer("small");
        let url = "";
        this.sharedService.customTheme = cloneDeep(theme);

        this.sharedService.currentDrawer = {
            title: "Color Palette",
            navLinks: null,
            saveMessage: "apply-theme-config"
        };
        url = "config-drawer/theme-config";
        this.sharedService.navigateToOutlet("drawer", url);
    }
}
